import { Button, Popover } from "antd";
import { suspressNegativeNumber, multipleValidate } from "helpers/functions";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import * as HMS from "../../../common/component/Index";
import Input from "../Input";
import "./styles.less"

const EachCellCustom = (props) => {
  const {
    classNameInput = "",
    className = "",
    titleEachCell = "",
    placeholderEachCell = "Input Number...",
    typeInputEachCell = "number",
    date,
    onChangeValue = () => {},
    defaultValue = 0,
    min = 0,
    valueRender,
    disablePopover
  } = props;

  //! State
  const ref = useRef();
  const [visiblePopover, setVisiblePopover] = useState(false);
  const [dateValue, setDateValue] = useState();
  const [valueChange, setValueChange] = useState(defaultValue);
  const [validation, setValidation] = useState({});
  const errorMsg = "Không thể nhập ít hơn số lượng đã bán";
  //! Function
  const onClickSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setVisiblePopover(false);
      onChangeValue(valueChange, date);
    }
  };

  const onChangeDateValue = (value) => {
    // const re = /^[1-9]+[0-9]*$/;
    setValueChange(value)
  }

  const onBlurDateValue = () => {
    if(dateValue === ''){
      setDateValue(defaultValue)
    }
  }

  const onVisibleChange = () => {
    setVisiblePopover(!visiblePopover)
  }

  useEffect(() => {
    setDateValue(defaultValue)
  }, [defaultValue])

  const validate = () => {
    let validate = {
        minValueNumber: {
          planQty: errorMsg,
        }
    };
    
    if(min > 0){
      validate.required = {
        planQty: errorMsg,
      }
    }

    let valueValidate = {
      minValueNumber: { planQty: min },
    };
    const result = multipleValidate({planQty: valueChange}, validate, valueValidate);
    setValidation(result);
    return Object.keys(result).length < 1;
  }

  const content = (
    <div className="d-flex align-items-end" style={{maxWidth: 350}}>
      <HMS.FormWrapperInputComponent
          isValidation={true}
          dataValidation={valueChange}
          validation={validation["planQty"]}
          className="m-0"
      >
        <Input
          name="planQty"
          value={valueChange}
          className={`each-cell-input ${classNameInput}`}
          placeholder={placeholderEachCell}
          type={typeInputEachCell}
          step={1}
          onBlur={(e) => onBlurDateValue()}
          onChange={(e) => onChangeDateValue(e.target.value)}
          onKeyDown={suspressNegativeNumber}
        />
      </HMS.FormWrapperInputComponent>
      <Button htmlType="button" onClick={onClickSubmit} className="ml-2" style={{height: 38}}>
        Submit
      </Button>
    </div>
  );

  const isPast = moment(date).isBefore(moment().startOf("D"));

  //! Render
  return (
    <Popover
      content={content}
      title={titleEachCell}
      trigger="click"
      visible={!disablePopover && visiblePopover}
      onVisibleChange={onVisibleChange}
    >
      <div
        ref={ref}
        className={`ant-fullcalendar-date ${className} ${
          dateValue < min ? "cld-warning" : ""
        } ${isPast ? "cld-date-past" : ""}`}
        title={dateValue < min ? errorMsg : ""}
      >
        <div className="ant-fullcalendar-value">{date.format("D")}</div>
        <div className="ant-fullcalendar-content">
          <div className="each-cell-calendar font-bold">
            {!visiblePopover && !valueRender ? dateValue : (typeof valueRender === 'function' ? valueRender(): null)}
          </div>
        </div>
      </div>
    </Popover>
  );
};

export default EachCellCustom;
